import React from 'react';
import { ShieldCheck } from 'lucide-react';

const Guarantee: React.FC = () => {
  return (
    <section className="py-16 bg-brand-blue">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-md rounded-[3rem] p-12 border border-white/20 flex flex-col md:flex-row items-center gap-12 text-white">
          <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center text-brand-blue shrink-0 shadow-xl">
            <ShieldCheck className="w-12 h-12" />
          </div>
          <div className="text-center md:text-left space-y-4">
            <h2 className="text-3xl font-black">100% Satisfaction Guarantee</h2>
            <p className="text-lg text-blue-50 leading-relaxed">
              Your happiness is our priority. If you're not completely satisfied with your cleaning, 
              let us know within 24 hours and we will return to make it right at no extra cost.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guarantee;
